"use client";
import {NeoButton} from "@/components/forms";
import {NeoError, NeoSuccess} from "@/components/shared";
import {useNeoContext} from "@/context/neo/neo.context";
import {creaditOverview} from "@/service/routePlan.service";
import {useState} from "react";

type CreditsPointFormProps = {
  onSubmit: () => void;
  onClose: () => void;
};

export const CreditsPointForm: React.FC<CreditsPointFormProps> = ({
  onSubmit,
  onClose
}) => {
  const {filterContext, offset} = useNeoContext();
  const [loginUserId, setLoginUserId] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const onAddCreditPoint = () => {
    setLoading(true);
    creaditOverview
      .updateCreditCoin()
      .then(response => {
        // console.log(response);
        if (response?.status === "success") {
          //console.log("s");
          setSuccessMessage(
            response?.message ?? "Request submitted successfully."
          );
        } else {
          setErrorMessage(response?.message ?? "Something went wrong");
        }
      })
      .catch(err => {})
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          onClose();
          setErrorMessage(null);
          setSuccessMessage(null);
        }, 5000);
      });
  };
  return (
    <div className="flex w-full flex-col p-2">
      <div className="flex flex-col items-center justify-center gap-3 rounded-lg bg-white p-6">
        <img
          src="/icons/routePlan/routePlancoin.svg"
          alt="credits"
          className="h-12 w-12"
        />
        <h2 className="text-lg font-bold text-gray-800">Get More Credits</h2>
        <p className="max-w-md text-center text-sm text-gray-500">
          A credit request will be sent to our team. Our team will review your
          request and reach out to you shortly to confirm your requirements.
        </p>
        {errorMessage ? <NeoError message={errorMessage}></NeoError> : null}
        {successMessage ? (
          <NeoSuccess message={successMessage}></NeoSuccess>
        ) : null}
      </div>

      <div className="mt-4 flex justify-center gap-5">
        <NeoButton type="button" color="white" onClick={onClose}>
          Cancel
        </NeoButton>
        <NeoButton className="" type="submit" onClick={onAddCreditPoint}>
          Confirm Request
        </NeoButton>
      </div>
    </div>
  );
};
